const facilityAreasPath = '/facilities/area';
export const getFacilityAreas = facilityAreasPath;
export const getFacilityAreaById = (id: number) => `${facilityAreasPath}/${id}`;
export const createFacilityArea = facilityAreasPath;
export const updateFacilityArea = (id: number) => `${facilityAreasPath}/${id}`;
export const getAreasRating = (branchId: number) => `/facilities/rating/branches/${branchId}/areas`